var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.loading,
          expression: "loading",
        },
      ],
    },
    [
      _c(
        "el-upload",
        {
          ref: "resourcesUp",
          staticClass: "drag-upload-cmp",
          attrs: {
            accept: _vm.accept,
            "auto-upload": _vm.autoUpload,
            "before-remove": _vm.beforeRemove,
            "before-upload": _vm.beforeUpload,
            "file-list": _vm.fileList,
            "http-request": _vm.enclosureUpload,
            limit: _vm.limit,
            multiple: _vm.multiple,
            "on-change": _vm.onFileChange,
            "on-exceed": _vm.handleExceed,
            "on-remove": _vm.handleRemove,
            "show-file-list": _vm.showFileList,
            action: "",
            drag: "",
          },
        },
        [
          _c("i", { staticClass: "el-icon-upload" }),
          _c("div", { staticClass: "el-upload__text" }, [
            _vm._v(_vm._s(_vm.uploadText)),
          ]),
          _vm.tips
            ? _c(
                "div",
                {
                  staticClass: "el-upload__tip",
                  attrs: { slot: "tip" },
                  slot: "tip",
                },
                [_vm._v(_vm._s(_vm.tips))]
              )
            : _vm._e(),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }